<section [hidden]="!loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" aria-label="Loading...">
  </mat-progress-bar>
</section>

<section [hidden]="loading">
  <mat-card class="phone-no-margin">
    <mat-card-header class="phone-no-margin">
      <mat-card-title id="partnerAccessTitle" class="phone-no-margin">
        <mat-icon class="icon-20">handshake</mat-icon> Partner Access <span [hidden]="partnerAccess == null ">: &nbsp;{{partnerAccess?.partnerName}}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row " [hidden]="partnerAccess == null ">
        <!-- Not validated -->
        <div fxLayout="column" [hidden]="validated">
          <!-- disclaimer -->
          <div fxLayout="row" [hidden]="validatedDisclaimer">
            <mat-card style="margin:2em;" class="mat-elevation-z0 phone-no-margin">
              <mat-card-header>
                <mat-card-title>
                  Partner Access Disclaimer
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div fxLayout="row">
                  <p class="white-space">
                    {{partnerAccess?.disclaimer}}
                  </p>
                </div>
                <div fxLayout="row">
                  <button mat-raised-button color="primary" (click)="acceptDisclaimer()">Accept</button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <!-- pass key -->
          <div fxLayout="row" [hidden]="validatedPassKey || !validatedDisclaimer">
            <mat-card style="margin:2em;" class="mat-elevation-z0 phone-no-margin">
              <mat-card-header>
                <mat-card-title>
                  Pass Key Required.
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div fxLayout="row">
                  <p class="white-space">
                    Please enter the 6 digit pass key provided by OHA.
                    <mat-form-field appearance="outline" class="example-form-field">
                      <input matInput type="text" maxlength="6" [(ngModel)]="passKey" placeholder="Pass Key*" required autocomplete="off" pattern="[0-9]*" (input)="sanitizePassKey(); checkPasskey()"
                        (keydown)="allowOnlyNumbers($event)" />
                    </mat-form-field>
                  </p>
                </div>
                <div fxLayout="row">
                  <button mat-raised-button id="sbtBtn" color="primary" (click)="submitPassKey()" [disabled]="!codeEntered">Submit</button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <!-- Validated -->
        <div fxLayout="column" *ngIf="validated &&  validatedPassKey">
          <!-- Lubgwma Plumber access -->
          <div fxLayout="row" *ngIf="partnerAccess?.accessType == partnerService.lubgwmaPlumber">
            <div>
              <app-partners-lubgwma-plumbers *ngIf="partnerAccess?.accessType == partnerService.lubgwmaPlumber && partnerId != null && partnerId > 0" class="lubgwma-plumbers-container"
                [partnerId]="partnerId" [accessGuid]="accessGuid" [passKey]="passKey"></app-partners-lubgwma-plumbers>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

</section>